/* Sezmar Professional: landing (data-sz-landing) and kit page (data-sz-kit). Vanilla JS, no dependencies.
   Scent choice is sent to the cart as line-item properties (properties[Scent] / properties[Scents]).
   After adding, the Eurus cart drawer is refreshed with the theme's own helpers; if anything is missing
   the visitor is sent to the cart page instead. */
(function () {
  'use strict';

  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function imgW(u, w) {
    if (!u) return '';
    return u.indexOf('?v=') > -1 ? u.replace('?v=', '?width=' + w + '&v=') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function pickLabel(tpl, n) {
    return String(tpl).replace('[n]', n).replace('[s]', n > 1 ? 's' : '');
  }
  function root(url) { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------- cart ---------- */
  function sectionsToRender() {
    try {
      var H = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
      return H && H.getSectionsToRender ? H.getSectionsToRender() : null;
    } catch (e) { return null; }
  }

  function refreshDrawer(res) {
    try {
      var list = sectionsToRender();
      if (!list || !res || !res.sections || typeof getSectionInnerHTML !== 'function') return false;
      list.forEach(function (s) {
        s.selector.split(',').forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el && res.sections[s.id]) el.innerHTML = getSectionInnerHTML(res.sections[s.id], sel);
        });
      });
      var mc = Alpine.store('xMiniCart');
      if (!mc || typeof mc.openCart !== 'function') return false;
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      setTimeout(function () { mc.openCart(); }, 300);
      return true;
    } catch (e) { return false; }
  }

  function addToCart(host, item, done) {
    var body = { items: [item] };
    var list = sectionsToRender();
    if (list) {
      body.sections = list.map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; });
    }).then(function (r) {
      if (!r.ok) { done(false, r.json && (r.json.description || r.json.message)); return; }
      if (!refreshDrawer(r.json)) { window.location.href = host.getAttribute('data-cart-url') || (root() + 'cart'); return; }
      done(true);
    }).catch(function () { done(false); });
  }

  function showError(el, host, msg) {
    if (!el) return;
    el.textContent = msg || host.getAttribute('data-l-error') || '';
    el.hidden = false;
  }

  function smoothAnchors(host) {
    host.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- landing ---------- */
  function initLanding(host) {
    var rows = qs(host, '[data-sz-rows]');
    var seg = qs(host, '[data-sz-seg]');
    var L = {
      add: host.getAttribute('data-l-add'),
      choose: host.getAttribute('data-l-choose'),
      pick: host.getAttribute('data-l-pick'),
      adding: host.getAttribute('data-l-adding')
    };
    if (qs(host, '.sz-sticky')) document.body.classList.add('sz-has-sticky');
    smoothAnchors(host);

    if (rows) {
      rows.addEventListener('click', function (e) {
        var row = e.target.closest('[data-sz-row]');
        if (!row) return;
        var chip = e.target.closest('.sz-chips button');
        var btn = qs(row, '[data-sz-add]');
        if (chip) {
          var max = +row.getAttribute('data-max'), min = +row.getAttribute('data-min');
          var cur = row._sel || (row._sel = []);
          var o = chip.getAttribute('data-o'), ix = cur.indexOf(o);
          if (ix > -1) cur.splice(ix, 1);
          else {
            if (max === 1) cur.length = 0;
            if (cur.length < max) cur.push(o);
          }
          qsa(row, '.sz-chips button').forEach(function (b) {
            b.setAttribute('aria-pressed', cur.indexOf(b.getAttribute('data-o')) > -1 ? 'true' : 'false');
          });
          var last = cur.length ? cur[cur.length - 1] : null;
          var sline = qs(row, '[data-sz-sline]');
          sline.textContent = '';
          if (last) {
            var bt = document.createElement('b');
            bt.textContent = last + ':';
            sline.appendChild(bt);
            var src = qsa(row, '.sz-chips button').filter(function (b) { return b.getAttribute('data-o') === last; })[0];
            sline.appendChild(document.createTextNode(' ' + (src ? src.getAttribute('data-blurb') : '')));
          }
          qs(row, '[data-sz-cnt]').textContent = max > 1 ? cur.length + '/' + max : '';
          var ok = cur.length >= min;
          if (btn) {
            btn.disabled = !ok;
            btn.textContent = ok ? L.add : (min > 1 ? pickLabel(L.pick, min - cur.length) : L.choose);
          }
          return;
        }
        var add = e.target.closest('[data-sz-add]');
        if (add && !add.disabled) {
          var item = { id: +row.getAttribute('data-variant'), quantity: 1 };
          var prop = row.getAttribute('data-prop');
          if (prop) {
            item.properties = {};
            item.properties[prop] = (row._sel || []).join(', ');
          }
          var err = qs(row, '[data-sz-err]');
          if (err) err.hidden = true;
          var label = add.textContent;
          add.disabled = true;
          add.textContent = L.adding;
          addToCart(host, item, function (ok2, msg) {
            add.disabled = false;
            add.textContent = label;
            if (!ok2) showError(err, host, msg);
          });
        }
      });
    }

    if (seg && rows) {
      seg.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var s = b.getAttribute('data-s');
        qsa(seg, 'button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        qsa(rows, '[data-sz-row]').forEach(function (r) {
          var segs = (r.getAttribute('data-seg') || '').split(' ');
          r.hidden = !(s === 'all' || segs.indexOf(s) > -1);
        });
      });
    }
  }

  /* ---------- kit page ---------- */
  function initKit(host) {
    var L = {
      add: host.getAttribute('data-l-add'),
      choose: host.getAttribute('data-l-choose'),
      pick: host.getAttribute('data-l-pick'),
      adding: host.getAttribute('data-l-adding'),
      of: host.getAttribute('data-l-of') || 'of',
      chooseScent: host.getAttribute('data-l-choose-scent') || ''
    };
    var addBtn = qs(host, '[data-sz-add]');
    var stickyBtn = qs(host, '[data-sz-sticky]');
    var readyLabel = addBtn ? addBtn.textContent : '';
    var errEl = qs(host, '[data-sz-err]');
    if (qs(host, '.sz-sticky')) document.body.classList.add('sz-has-sticky');
    smoothAnchors(host);

    var dataEl = qs(host, '[data-sz-data]');
    var D = null;
    try { D = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { D = null; }
    var sel = D && D.defaults ? D.defaults.slice() : [];

    function nameOf(k) { return D && D.products[k] ? D.products[k].name : k; }
    function poolFirst() { return D && D.pool && D.pool.length ? D.pool[0].key : null; }
    function poolName(k) {
      for (var i = 0; i < D.pool.length; i++) if (D.pool[i].key === k) return D.pool[i].name;
      return k;
    }
    function ready() { return !D || !D.scent || sel.length >= D.scent.min; }

    function gallery() {
      var g = D.gallery || {};
      if (g.fixed) return g.fixed.slice();
      var out = (g.lead || []).slice();
      if (D.scent) {
        var fill = sel.length ? sel : [poolFirst()];
        if (fill.length === 1 && g.repeat > 0) { for (var i = 0; i < g.repeat; i++) out.push(fill[0]); }
        else out = out.concat(fill);
      }
      return out.concat(g.extra || []);
    }

    function renderStage(items) {
      var set = qs(host, '[data-sz-stage]');
      var th = qs(host, '[data-sz-thumbs]');
      set.className = 'sz-set sz-n' + items.length;
      set.innerHTML = items.map(function (k) { return '<img src="' + esc(imgW(D.products[k].img, 700)) + '" alt="" width="700" height="700">'; }).join('');
      var uniq = items.filter(function (v, i) { return items.indexOf(v) === i; });
      th.innerHTML = uniq.map(function (k, i) {
        return '<button type="button" data-p="' + esc(k) + '" aria-current="' + (i === 0) + '" aria-label="' + esc(D.products[k].title) + '"><img src="' + esc(imgW(D.products[k].img, 200)) + '" alt="" width="200" height="200"></button>';
      }).join('');
    }

    function renderIncluded() {
      var ul = qs(host, '[data-sz-inc]');
      if (!ul) return;
      function li(img, t, s) {
        return '<li><div class="sz-im"><img src="' + esc(imgW(img, 200)) + '" alt="" width="200" height="200"></div><div><b>' + esc(t) + '</b><small>' + esc(s) + '</small></div></li>';
      }
      var h = '';
      D.fixed.forEach(function (f) { if (f.before) h += li(D.products[f.key].img, f.label, f.note); });
      if (D.scent) {
        var first = sel[0] || poolFirst();
        h += li(D.products[first].img, D.scent.rowLabel, sel.length ? sel.map(poolName).join(' + ') : L.chooseScent);
      }
      D.fixed.forEach(function (f) { if (!f.before) h += li(D.products[f.key].img, f.label, f.note); });
      ul.innerHTML = h;
    }

    function renderCards() {
      var cards = qsa(host, '.sz-pc');
      var shown = [];
      cards.forEach(function (c) {
        var k = c.getAttribute('data-key');
        var fixed = c.getAttribute('data-fixed') === '1';
        var si = sel.indexOf(k);
        var vis = fixed || si > -1;
        c.hidden = !vis;
        var rank = +c.getAttribute('data-rank') || 0;
        var idx = fixed ? cards.filter(function (x) { return x.getAttribute('data-fixed') === '1'; }).indexOf(c) : 10 + si;
        var order = rank * 100 + idx;
        c.style.order = order;
        if (vis) shown.push({ el: c, order: order });
      });
      shown.sort(function (a, b) { return a.order - b.order; });
      var jump = qs(host, '[data-sz-jump]');
      var jh = '';
      shown.forEach(function (s, i) {
        var c = s.el;
        var role = c.getAttribute('data-role'), note = c.getAttribute('data-note');
        qs(c, '[data-sz-eyebrow]').textContent = (i + 1) + ' ' + L.of + ' ' + shown.length + ' · ' + role + (note ? ' · ' + note : '');
        jh += '<a href="#' + esc(c.id) + '">' + esc(c.getAttribute('data-name')) + '</a>';
      });
      if (jump) jump.innerHTML = jh;
      qsa(host, '[data-sz-allergen]').forEach(function (p) {
        var k = p.getAttribute('data-sz-allergen');
        var c = qs(host, '#pb-' + k);
        p.hidden = !c || c.hidden;
      });
      var sn = qs(host, '[data-sz-step-name]');
      if (sn) sn.textContent = nameOf(sel[0] || poolFirst());
    }

    function renderButtons() {
      var ok = ready();
      if (addBtn) {
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? readyLabel : (D.scent && D.scent.min > 1 ? pickLabel(L.pick, D.scent.min - sel.length) : L.choose);
      }
      if (stickyBtn) stickyBtn.disabled = !ok;
    }

    function renderAll() {
      if (!D) return;
      renderStage(gallery());
      renderIncluded();
      renderCards();
      renderButtons();
    }

    var scents = qs(host, '[data-sz-scents]');
    if (scents && D) {
      scents.addEventListener('change', function (e) {
        var v = e.target.value;
        if (D.scent.max === 1) sel = [v];
        else {
          var i = sel.indexOf(v);
          if (i > -1) sel.splice(i, 1);
          else if (sel.length < D.scent.max) sel.push(v);
          else { e.target.checked = false; return; }
        }
        renderAll();
      });
    }

    var thumbs = qs(host, '[data-sz-thumbs]');
    if (thumbs && D) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var k = b.getAttribute('data-p');
        var set = qs(host, '[data-sz-stage]');
        set.className = 'sz-set sz-n1';
        set.innerHTML = '<img src="' + esc(imgW(D.products[k].img, 700)) + '" alt="" width="700" height="700">';
        qsa(thumbs, 'button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var item = { id: +host.getAttribute('data-variant'), quantity: 1 };
        if (D && D.scent) {
          item.properties = {};
          item.properties[D.scent.prop] = sel.map(poolName).join(', ');
        }
        if (errEl) errEl.hidden = true;
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = L.adding;
        addToCart(host, item, function (ok, msg) {
          addBtn.disabled = false;
          addBtn.textContent = label;
          if (!ok) showError(errEl, host, msg);
        });
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var t = document.getElementById('sz-buy');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    renderAll();
  }

  function boot() {
    qsa(document, '[data-sz-landing]').forEach(initLanding);
    qsa(document, '[data-sz-kit]').forEach(initKit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
